module.exports = __webpack_public_path__ + "img/home-img-1.4f35d0c1.jpg";